module.exports = __webpack_public_path__ + "mainassets/img/floating-objects-404.af323042.svg";